import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import _ from 'lodash';
import SelectField, { mapOptionsToSelectField } from '../../../shared-components/SelectField/SelectField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { Field } from 'redux-form';


const LOCALE_PREFIX = 'GB/components/FinancialInfo/FinancialInfo';

export class MonthlyIncome extends Component {
    static propTypes = {
        currencySymbol:PropTypes.string.isRequired,
        intl: intlShape.isRequired,
        monthlyIncomeListOptions: PropTypes.object.isRequired,
        financialInfo: PropTypes.object.isRequired
    };

    render() {
        const { intl, monthlyIncomeListOptions, currencySymbol, financialInfo } = this.props;

        _.forEach(monthlyIncomeListOptions, (value, key) => {
            monthlyIncomeListOptions[key] = value.replace(/{currencySymbol}/g, currencySymbol);
        });

        return (
            <Field
                id="netMonthlyIncome"
                name="netMonthlyIncome"
                component={SelectField}
                optionList={mapOptionsToSelectField(monthlyIncomeListOptions)}
                required={true}
                label={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.income`})}
                placeholder={intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.income`})}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.income-empty`}))]}
            />
        );
    }
}

export const mapStateToProps = state => ({
    // Grab the properties directly from the message object
    currencySymbol: _.get(state, 'serverData.currencySymbol'),
    monthlyIncomeListOptions: _.get(state, `serverData.messages[${LOCALE_PREFIX}].applyForBmlUK.incomeRange`),
    financialInfo: _.get(state, 'form.ppcreditapply.values.financial-info')
});

export default connect(mapStateToProps)(injectIntl(MonthlyIncome));
